import { hideProgress, showProgress } from "@/stores/progress";
import client from "@/utils/api/client";
import { useState } from "react";
import { useDispatch } from "react-redux";
import pSeries from "p-series";
import { ListItemResponse } from "@/web-client/api";

interface SelectableItemEvent {
  selected: boolean;
  item: ListItemResponse;
}

export interface EditListItemsResponse {
  isEditing: boolean;
  isSelectedItem(item: ListItemResponse): boolean;
  editHandler(): void;
  editCompleteHandler(): void;
  selectHandler(event: SelectableItemEvent): void;
  deleteHandler(): void;
  selectedItems: ListItemResponse[];
}

const useEditListItems = (listId: number): EditListItemsResponse => {
  const dispatch = useDispatch();
  const [isEditing, setIsEditing] = useState(false);
  const [selectedItems, setSelectedItems] = useState<ListItemResponse[]>([]);

  const isSelectedItem = (item: ListItemResponse): boolean => {
    return selectedItems.findIndex((i) => i.id === item.id) >= 0;
  };

  const editHandler = () => {
    setIsEditing(true);
  };

  const editCompleteHandler = () => {
    setIsEditing(false);
    setSelectedItems([]);
  };

  const selectHandler = (event: SelectableItemEvent) => {
    if (event.selected) {
      setSelectedItems([...selectedItems, event.item]);
    } else {
      setSelectedItems(selectedItems.filter((i) => i.id != event.item.id));
    }
  };

  const deleteHandler = async () => {
    dispatch(showProgress());

    const promises = selectedItems.map((item) => {
      return () => {
        return new Promise<void>((resolve, reject) => {
          try {
            const request = client.listsListIdItemsItemIdDelete({
              listId,
              itemId: item.id,
            });
            request.then(() => resolve());
          } catch {
            reject();
          }
        });
      };
    });

    try {
      await pSeries(promises);
      alert("選択されたアイテムをリストから削除しました");
      setSelectedItems([]);
      window.location.reload();
    } catch {
      alert("削除に失敗しました");
    }

    dispatch(hideProgress());
  };

  return {
    isEditing,
    isSelectedItem,
    editHandler,
    editCompleteHandler,
    selectHandler,
    deleteHandler,
    selectedItems,
  };
};

export default useEditListItems;
